// PWA helpers — service worker registration + Add-to-Home-Screen prompt management
export function registerServiceWorker() {
  if (!("serviceWorker" in navigator)) return;
  if (window.location.hostname === "localhost") return; // skip on local dev
  window.addEventListener("load", () => {
    navigator.serviceWorker
      .register("/sw.js")
      .then((reg) => {
        // eslint-disable-next-line no-console
        console.log("[Habano] sw registered:", reg.scope);
      })
      .catch((err) => {
        // eslint-disable-next-line no-console
        console.warn("[Habano] sw registration failed:", err);
      });
  });
}

let deferredPrompt = null;
const listeners = new Set();

if (typeof window !== "undefined") {
  window.addEventListener("beforeinstallprompt", (e) => {
    e.preventDefault();
    deferredPrompt = e;
    listeners.forEach((fn) => fn(true));
  });
  window.addEventListener("appinstalled", () => {
    deferredPrompt = null;
    listeners.forEach((fn) => fn(false));
  });
}

export function canInstall() {
  return !!deferredPrompt;
}

export async function promptInstall() {
  if (!deferredPrompt) return "unavailable";
  deferredPrompt.prompt();
  const choice = await deferredPrompt.userChoice;
  deferredPrompt = null;
  listeners.forEach((fn) => fn(false));
  return choice.outcome; // "accepted" | "dismissed"
}

export function subscribeInstall(cb) {
  listeners.add(cb);
  cb(!!deferredPrompt);
  return () => listeners.delete(cb);
}

export async function requestGeolocation() {
  if (!("geolocation" in navigator)) return { ok: false, reason: "unsupported" };
  return new Promise((resolve) => {
    navigator.geolocation.getCurrentPosition(
      (pos) => resolve({ ok: true, lat: pos.coords.latitude, lng: pos.coords.longitude, accuracy: pos.coords.accuracy }),
      (err) => resolve({ ok: false, reason: err.message }),
      { enableHighAccuracy: true, timeout: 10000, maximumAge: 60000 }
    );
  });
}
